import { SELECTED_CLIENT_KEY, SELECTED_ENTITY_KEY, SELECTED_SEGMENT_KEY, USER_ID_KEY, } from '../../constants';
import { ClientModel, EntityModel, SegmentModel } from '../../models';
import { storage } from '../storage';
//Even though we store the Model, when it is returned it is just an object with the same keys, not getters and setters.
//If we update the functions in the model it may not always be reflected in the obj returned from storage
const convertSegmentToSegmentResponse = (obj) => {
    const segmentReponseData = {
        id: obj.id,
        name: obj.name,
        entity_id: obj.entityId,
        processing_channel_ids: obj.processingChannelIds,
        brand: obj.brand,
        business_category: obj.businessCategory,
        status: obj.status,
        dimension_hash: obj.dimensionHash,
    };
    return segmentReponseData;
};
const convertEntityToEntityResponse = (obj) => {
    const entityResponseData = {
        entity_id: obj.id,
        entity_segments: obj.entitySegments
            ? obj.entitySegments.map(convertSegmentToSegmentResponse)
            : [],
        name: obj.name,
        onboards_sub_entities: obj.onboardsSubEntities,
    };
    return entityResponseData;
};
const convertClientToClientResponse = (obj) => {
    const clientResponseData = {
        client_id: obj.id,
        name: obj.name,
        entities: obj.entities ? obj.entities.map(convertEntityToEntityResponse) : [],
    };
    return clientResponseData;
};
export const userStorage = {
    getClient: () => {
        const clientResponse = storage.get(SELECTED_CLIENT_KEY);
        if (clientResponse) {
            return ClientModel.from(convertClientToClientResponse(clientResponse));
        }
        return clientResponse;
    },
    setClient: (clientModel) => {
        storage.set(SELECTED_CLIENT_KEY, clientModel);
    },
    clearClient: () => {
        storage.remove(SELECTED_CLIENT_KEY);
    },
    getEntity: () => {
        const storedEntity = storage.get(SELECTED_ENTITY_KEY);
        if (storedEntity) {
            return EntityModel.from(convertEntityToEntityResponse(storedEntity));
        }
        return storedEntity;
    },
    setEntity: (entityModel) => {
        storage.set(SELECTED_ENTITY_KEY, entityModel);
    },
    clearEntity: () => {
        storage.remove(SELECTED_ENTITY_KEY);
    },
    getSegment: () => {
        const storedSegment = storage.get(SELECTED_SEGMENT_KEY);
        if (storedSegment) {
            return SegmentModel.from(convertSegmentToSegmentResponse(storedSegment));
        }
        return storedSegment;
    },
    setSegment: (segmentModel) => {
        storage.set(SELECTED_SEGMENT_KEY, segmentModel);
    },
    clearSegment: () => {
        storage.remove(SELECTED_SEGMENT_KEY);
    },
    getUserId: () => {
        return storage.get(USER_ID_KEY);
    },
    isUserFromPreviousSession: (userId) => {
        return storage.get(USER_ID_KEY) === userId;
    },
    setUserId: (userId) => {
        storage.set(USER_ID_KEY, userId);
    },
    clearAll: () => {
        storage.remove(SELECTED_CLIENT_KEY);
        storage.remove(SELECTED_ENTITY_KEY);
        storage.remove(SELECTED_SEGMENT_KEY);
        storage.remove(USER_ID_KEY);
    },
};
